import React, { useState } from "react";
import {
  Button,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { changeAndPersistLanguage } from "../services/localizationService";
import { saveProfilePreferences } from "../services/profileSettingService";
import {
  getPreferredTimeZone,
  persistPreferredTimeZone,
} from "../utils/userPreferences";

const TIME_ZONES = [
  "America/Santo_Domingo",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "UTC",
];

export default function LocalizationPreferences() {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(
    i18n.resolvedLanguage === "en" ? "en" : "es"
  );
  const [timeZone, setTimeZone] = useState(getPreferredTimeZone());
  const [saved, setSaved] = useState(false);

  const save = async () => {
    persistPreferredTimeZone(timeZone);
    await changeAndPersistLanguage(language);
    try {
      await saveProfilePreferences({
        language,
        locale: language === "en" ? "en-US" : "es-DO",
        timeZone,
      });
    } catch (error) {
      // Local persistence keeps the preference usable while the API is unavailable.
    }
    setSaved(true);
  };

  return (
    <Card style={{ marginBottom: 24, borderRadius: 20 }}>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          {t("settings.localization")}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {t("settings.localizationDescription")}
        </Typography>
        <FormControl variant="outlined" fullWidth margin="normal">
          <InputLabel id="language-preference-label">
            {t("settings.language")}
          </InputLabel>
          <Select
            labelId="language-preference-label"
            value={language}
            onChange={(event) => setLanguage(event.target.value)}
            label={t("settings.language")}
          >
            <MenuItem value="es">{t("settings.spanish")}</MenuItem>
            <MenuItem value="en">{t("settings.english")}</MenuItem>
          </Select>
        </FormControl>
        <FormControl variant="outlined" fullWidth margin="normal">
          <InputLabel id="timezone-preference-label">
            {t("settings.timeZone")}
          </InputLabel>
          <Select
            labelId="timezone-preference-label"
            value={timeZone}
            onChange={(event) => setTimeZone(event.target.value)}
            label={t("settings.timeZone")}
          >
            {TIME_ZONES.map((zone) => (
              <MenuItem key={zone} value={zone}>
                {zone}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button variant="contained" color="primary" onClick={save}>
          {t("common.save")}
        </Button>
        {saved && (
          <Typography color="primary" style={{ marginTop: 10 }}>
            {t("settings.saved")}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
